import { api } from '@/lib/api';

/** Row returned by `POST media/upload`. */
export interface MediaFile { id: number; url: string; path: string; name: string; mime: string; size: number; created_at?: string }

export const MAX_UPLOAD_BYTES = 10 * 1024 * 1024;
export const UPLOAD_ACCEPT = '.jpg,.jpeg,.png,.gif,.webp,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.mp4,.mp3';

/** Uploads one file to `media/upload` (multipart, field `file`) and returns the stored file row. */
export async function uploadMedia(file: File, opts?: { relatedType?: string; relatedId?: number | string; onProgress?: (pct: number) => void }): Promise<MediaFile> {
  if (file.size > MAX_UPLOAD_BYTES) throw new Error('This file is larger than 10 MB.');
  const fd = new FormData();
  fd.append('file', file);
  if (opts?.relatedType) fd.append('related_type', opts.relatedType);
  if (opts?.relatedId != null) fd.append('related_id', String(opts.relatedId));
  const r = await api.post('/media/upload', fd, {
    onUploadProgress: (e) => { if (opts?.onProgress && e.total) opts.onProgress(Math.round((e.loaded / e.total) * 100)); },
  });
  const body = r.data;
  return (body && typeof body === 'object' && 'success' in body ? body.data : body) as MediaFile;
}

export const fileSize = (n?: number | null) => {
  if (!n && n !== 0) return '';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
};
